import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { WorkerService } from '../service/worker.service';
import { SellerApiService } from '../../seller/service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { NewProjects, ReportTimeWork, UpdateReportTimeWork } from '../../seller/seller';
import { WorkerInfo } from '../worker';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'app-timesheets',
  templateUrl: './timesheets.component.html',
  styleUrls: ['./timesheets.component.scss']
})
export class TimesheetsComponent implements OnInit {

  @ViewChild('reporttimeModalOpen') openReportTimeModal: ElementRef;
  @ViewChild('reporttimeModalOpenworker') openReportWorkerModal: ElementRef;
  @ViewChild('reporttimemodalClose') reporttimemodalClose: ElementRef;
  @ViewChild('reporttimeform') reportworkerform: NgForm;

  // define worker name
  workerFirstname: string;
  buyerDisplayName: string;
  agreedProjects: Array<NewProjects> = [];
  workerInfo: WorkerInfo;

  public currentWorkerUserId: number = null;
  public currentWorkerId: number = null;
  public currentSellerUserId: number = null;
  public currentSellerId: number = null;
  public currentprojectId: number = null;
  currentWorkerProfilePic: string;
  loaderActivate: boolean;
  // tslint:disable-next-line:no-inferrable-types
  isActiveIndex: number = 0;
  reportworkersuccessmessage: string;
  reporttimework: ReportTimeWork;
  timesheetsByprojectId: any = {
    worker_time_sheets_as_dict: {
      first_name: ''
    }
  };
  isSelectedWorkerReport: boolean;
  isedittimesheet: boolean;
  isSelectedTimesheetView: string;
  monthViewDatePicker: Date;
  weekViewDatePicker: Date;
  startDateMonth: string;
  endDateMonth: string;
  monthviewDisplayDate: string;
  weekviewDisplayDate: string;
  startDateWeek: string;
  endDateWeek: string;
  disabledToEdit: boolean;
  istimereport_enabled: boolean;

  constructor(private workerService: WorkerService, private sellerService: SellerApiService,
    private cognitoService: CognitoUtil,
    public datepipe: DatePipe) {
  }

  ngOnInit() {

    this.reporttimework = new ReportTimeWork();
    this.workerInfo = new WorkerInfo();
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.workerFirstname = localStorage.getItem('yasoUserFirstName');
    this.loaderActivate = true;
    this.isSelectedTimesheetView = 'Month';
    this.monthViewDatePicker = new Date();
    this.weekViewDatePicker = new Date();

    this.reporttimework.travel_type = 'Private';
    this.reporttimework.is_travel_cost_enabled = false;
    this.reporttimework.date = new Date().toLocaleDateString();

    // tslint:disable-next-line:prefer-const
    let findDate = this.getStartDateAndEndDate(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth());
    this.startDateMonth = findDate.startDate;
    this.endDateMonth = findDate.endDate;
    this.setDisplayValueMonthAndWeek(this.monthViewDatePicker.getFullYear(), this.monthViewDatePicker.getMonth(), 'Project');
    // Week Implementaion
    // tslint:disable-next-line:prefer-const
    let findweekDate = this.getStartDateAndEndDateForWeek(this.weekViewDatePicker.toLocaleDateString());
    this.startDateWeek = findweekDate.startDate;
    this.endDateWeek = findweekDate.endDate;
    this.setDisplayValueForWeek('Project');

    // userDetails.username = 'workerone@gmail.com';
    //  get current user id and  current user profile picture
    if (userDetails.username != null) {
      this.workerService.getworkerDetailsByWorker_UserName(userDetails.username).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          this.workerInfo = res;
          // Define Worker Id and Particular Seller Id Define for that Person
          this.currentWorkerUserId = res.user_id;
          this.currentWorkerId = res.worker_id;
          this.currentSellerUserId = res.seller_user_id;
          this.currentSellerId = res.seller_id;
          this.showAllAgreedProjectsByWorkerId(this.currentWorkerId);
          // tslint:disable-next-line:max-line-length
          (res.image_url === undefined) ? this.currentWorkerProfilePic = '../assets/images/profileImg.png' : this.currentWorkerProfilePic = res.image_url;

        }
      }, err => {
        console.log(err);
      });
    }

  }

  // get All Agreed Projects By Worker_id
  showAllAgreedProjectsByWorkerId(worker_id: number) {
    this.loaderActivate = true;
    // Get Agreed Project details and Load to display in the List
    this.workerService.getAllAgreedProjectsByWorker_id(worker_id).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.agreedProjects = res;
        if (this.agreedProjects.length > 0) {
          this.callProjectDetails(res[0].project_id, 0);
        }
      }
    }, err => {
      console.log(err);
    });
  }

    // Call The View of Time Sheets
  callDisplayView(value: string): void {
    this.isSelectedTimesheetView = value;
    if (value === 'Month') {
      // this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
     // this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateWeek, this.endDateWeek);
    }
  }


  // Call Project Details
  callProjectDetails(projectid: number, index: number): void {
    this.currentprojectId = projectid;
    this.isActiveIndex = index;
    // this.getAllWorkersList(this.projectId);
    // this.getUnAssignWorkersList(this.projectId);
    // Call the Time Sheet accoring to the Selected view
    if (this.isSelectedTimesheetView === 'Month') {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
      this.timesheetsByprojectId.users_time_sheets_as_dict = [];
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateWeek, this.endDateWeek);
    }
  }

  // Update Time Sheet
  updatetimeSheet(item: any, index: number, subi: number, istimereport_enabled): void {
    this.disabledToEdit = false;
    this.reportworkersuccessmessage = '';
    this.isedittimesheet = true;
    this.istimereport_enabled = istimereport_enabled;
    this.openReportTimeModal.nativeElement.click();

    this.reporttimework = new ReportTimeWork();
    // tslint:disable-next-line:max-line-length
    (item.travel_type === 0 || item.travel_type === undefined) ?  this.reporttimework.travel_type = 'Private' :  this.reporttimework.travel_type = 'Corporate' ;
    (item.is_travel_cost_enabled === undefined) ? this.reporttimework.is_travel_cost_enabled = true  : this.reporttimework.is_travel_cost_enabled = item.is_travel_cost_enabled;
    this.reporttimework.hours = item.hours;
    this.reporttimework.travel_distance = item.travel_distance;
    this.reporttimework.date = item.date;
    this.reporttimework.comment = (item.comment === undefined) ? '' : item.comment;
    this.reporttimework.reason = (item.reason === undefined) ? '' : item.reason;
    if (item.hours !== '00:00') {
      this.disabledToEdit = true;
    }
  }


  clearReportTimeModal(): void {
    this.reportworkersuccessmessage = '';
    this.isSelectedWorkerReport = false;
    if (!this.isedittimesheet) {
      this.reportworkerform.resetForm();
      this.reporttimework = new ReportTimeWork();
      this.reporttimework.travel_type = 'Private';
      this.reportworkerform.form.get('is_travel_cost_enabled').setValue(false);
      this.reportworkerform.form.get('date').setValue(new Date());
    }
    this.disabledToEdit = false;
    this.isedittimesheet = false;
  }

  // Report Time Call Post Method
  callReportTime(model: any, isValid: boolean): void {
    this.reportworkersuccessmessage = '';
    if (!isValid) {
      return;
    }
    // tslint:disable-next-line:prefer-const
    if (!this.Check_arrival(model.hours)) {
      return;
    }
    this.reporttimework.project_id = this.currentprojectId;
    if (this.reporttimework.project_id === null || this.reporttimework.project_id === undefined) {
      return;
    }

    this.reporttimework.date = this.datepipe.transform(this.reporttimework.date, 'yyyy-MM-dd hh:mm:ss');
    this.loaderActivate = true;
    // tslint:disable-next-line:prefer-const
    let backObj: UpdateReportTimeWork = new UpdateReportTimeWork();
    // backObj = this.reporttimework;
    backObj.hours = this.reporttimework.hours + ':00';
    backObj.project_id = this.reporttimework.project_id;
    backObj.user_id = this.currentWorkerUserId;
    backObj.date = this.reporttimework.date;
    backObj.is_travel_cost_enabled = this.reporttimework.is_travel_cost_enabled;
    backObj.comment = (this.reporttimework.comment === undefined) ? '' : this.reporttimework.comment;
    backObj.reason = (this.reporttimework.reason === undefined) ? '' : this.reporttimework.reason;
    backObj.travel_distance = (this.reporttimework.travel_distance === undefined) ? 0 : Number(this.reporttimework.travel_distance);
    (this.reporttimework.travel_type === 'Private') ? backObj.travel_type = 0 : backObj.travel_type = 1;
    this.sellerService.reporttimeByProjectId(backObj).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.reportworkersuccessmessage = 'Successfully added';
        this.reporttimemodalClose.nativeElement.click();
          if (this.isSelectedTimesheetView === 'Month') {
            this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
              this.startDateMonth, this.endDateMonth);
          } else {
            this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
              this.startDateWeek, this.endDateWeek);
          }

        this.isedittimesheet = false;
        this.isSelectedWorkerReport = false;
      }
    }, err => {
      console.log(err);
    });
  }

  Check_arrival(time) {
    // Assuming you are working in 12 hour time, 0 is not a valid
    // tslint:disable-next-line:prefer-const
    let patt = new RegExp('^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
    // tslint:disable-next-line:prefer-const
    let res = patt.test(time);
    return res;
  }


  // Time sheets Project By Id and Worker Id
  getTimesheetsByProjctId_and_Worker_User_Id(project_id: number, worker_user_id: number,
    startdate: string, enddate: string): void {
    this.loaderActivate = true;
    // Call workers by Projects
    this.workerService.getshowtimesheetsByProject_and_worker(project_id, worker_user_id, startdate, enddate).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.timesheetsByprojectId = res;
      }
    }, err => {
      console.log(err);
    });

  }

  // Get the Date week
  getWeekValue(datestring: string): string {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    // tslint:disable-next-line:prefer-const
    let days = new Array(7);
    days[0] = 'Su';
    days[1] = 'Mo';
    days[2] = 'Tu';
    days[3] = 'We';
    days[4] = 'Th';
    days[5] = 'Fr';
    days[6] = 'Sa';
    return days[a.getDay()];
  }

  // Get the Weeb for Week View
  getWeekValueByWeekview(datestring: string): string {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    // tslint:disable-next-line:prefer-const
    let days = new Array(7);
    days[0] = 'Sun';
    days[1] = 'Mon';
    days[2] = 'Tus';
    days[3] = 'Wed';
    days[4] = 'Thu';
    days[5] = 'Fri';
    days[6] = 'Sat';
    return days[a.getDay()];
  }

  // Get the Date
  getDateByDatestring(datestring: string): number {
    // tslint:disable-next-line:prefer-const
    let a = new Date(datestring);
    return a.getUTCDate();
  }

  // Get All Days from Months to Disable
  getDaysInMonth(month, year) {
    // Since no month has fewer than 28 days
    // tslint:disable-next-line:prefer-const
    let date = new Date(year, month, 1);
    // tslint:disable-next-line:prefer-const
    let days = [];
    console.log('month', month, 'date.getMonth()', date.getMonth());
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }


  // Get the Start Date and End Date Object By Passing Year and Month
  getStartDateAndEndDate(year: number, month: number): any {
    // GET THE FIRST AND LAST DATE OF THE MONTH.
    // tslint:disable-next-line:prefer-const
    let firstDay = new Date(year, month, 1);
    // tslint:disable-next-line:prefer-const
    let lastDay = new Date(year, month + 1, 0);

    // tslint:disable-next-line:prefer-const
    let mmfirst = (firstDay.getMonth() + 1 < 10) ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddfirst = (firstDay.getDate() < 10) ? '0' + firstDay.getDate() : firstDay.getDate();

    // tslint:disable-next-line:prefer-const
    let mmlast = (lastDay.getMonth() + 1 < 10) ? '0' + (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddlast = (lastDay.getDate() < 10) ? '0' + lastDay.getDate() : lastDay.getDate();

    // tslint:disable-next-line:max-line-length
    // this.startDateMonth = firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst;
    // this.endDateMonth = lastDay.getFullYear() + '-' + mmlast + '-' + ddlast;

    return {
      startDate: firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst,
      endDate: lastDay.getFullYear() + '-' + mmlast + '-' + ddlast
    };

  }


  // Get the StartDate and EndDate For Week
  getStartDateAndEndDateForWeek(date: string): any {
    // tslint:disable-next-line:prefer-const
    let curr = this.momentDateFormat(date, 'MM/DD/YYYY'); // new Date(date); // get current date
    // tslint:disable-next-line:prefer-const
    let currlst = this.momentDateFormat(date, 'MM/DD/YYYY'); // new Date(date); // get current date
    // tslint:disable-next-line:prefer-const
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    // tslint:disable-next-line:prefer-const
    let last = first + 6; // last day is the first day + 6

    // tslint:disable-next-line:prefer-const
    let firstDay = new Date(curr.setDate(first));
    // tslint:disable-next-line:prefer-const
    let lastDay = new Date(currlst.setDate(last));

    // tslint:disable-next-line:prefer-const
    let mmfirst = (firstDay.getMonth() + 1 < 10) ? '0' + (firstDay.getMonth() + 1) : (firstDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddfirst = (firstDay.getDate() < 10) ? '0' + firstDay.getDate() : firstDay.getDate();

    // tslint:disable-next-line:prefer-const
    let mmlast = (lastDay.getMonth() + 1 < 10) ? '0' + (lastDay.getMonth() + 1) : (lastDay.getMonth() + 1);
    // tslint:disable-next-line:prefer-const
    let ddlast = (lastDay.getDate() < 10) ? '0' + lastDay.getDate() : lastDay.getDate();

    return {
      startDate: this.findNextDayByPassingDate(firstDay.getFullYear() + '-' + mmfirst + '-' + ddfirst),
      endDate: this.findNextDayByPassingDate(lastDay.getFullYear() + '-' + mmlast + '-' + ddlast)
    };
  }

  momentDateFormat(date, dateformat): Date {
    return moment(date, dateformat).toDate();
  }

  // find Next from passing Date
  findNextDayByPassingDate(date) {
    // tslint:disable-next-line:prefer-const
    let findate = moment(date).add(1, 'days');
    return findate.format('YYYY-MM-DD');
  }


  // Set the Display Value for Month
  setDisplayValueMonthAndWeek(year: number, month: number, type: string) {
    if (month === 12) {
      month = 0;
      year = year + 1;
    }
    if (month === -1) {
      month = 11;
      year = year - 1;
    }

    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    if (type === 'Project') {
      this.monthviewDisplayDate = monthNames[month] + ', ' + year;
    }
  }

  // Set the  display Value for Week View
  setDisplayValueForWeek(type: string) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    if (type === 'Project') {
      // tslint:disable-next-line:max-line-length
      this.weekviewDisplayDate = monthNames[new Date(this.startDateWeek).getMonth()] + ' ' + new Date(this.startDateWeek).getDate() + '-' + new Date(this.endDateWeek).getDate() + ', ' + new Date(this.endDateWeek).getFullYear();

    }
  }


  // Call Month Change Event In Month View
  callOnMonthChangeEvent($event, type: string) {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
      // this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Worker');
      // // tslint:disable-next-line:prefer-const
      // let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      // this.startDateMonthWorker = findDate.startDate;
      // this.endDateMonthWorker = findDate.endDate;
      // this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }

  }

  // Call Year Change Event In Month View
  callOnYearChangeEvent($event, type: string) {
    if (type === 'Project') {
      this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
      // this.setDisplayValueMonthAndWeek($event.year, $event.month - 1, 'Worker');
      // // tslint:disable-next-line:prefer-const
      // let findDate = this.getStartDateAndEndDate($event.year, $event.month - 1);
      // this.startDateMonthWorker = findDate.startDate;
      // this.endDateMonthWorker = findDate.endDate;
      // this.getTimesheetsbyCurrentUserId(this.workeruserid, this.startDateMonthWorker, this.endDateMonthWorker);
    }
  }

  // Right Arrow for Month View
  onChangeMonthViewRight(type: string): void {
    if (type === 'Month') {
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() + 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() + 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.endDateWeek);
      findnewdate.setDate(findnewdate.getDate() + 2);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeek = findweekDate.startDate;
      this.endDateWeek = findweekDate.endDate;
      this.setDisplayValueForWeek('Project');
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateWeek, this.endDateWeek);

    }
  }

  // Left Arrow for Month View
  onChangeMonthViewLeft(type: string): void {
    if (type === 'Month') {
      this.setDisplayValueMonthAndWeek(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() - 1, 'Project');
      // tslint:disable-next-line:prefer-const
      let findDate = this.getStartDateAndEndDate(new Date(this.endDateMonth).getFullYear(), new Date(this.endDateMonth).getMonth() - 1);
      this.startDateMonth = findDate.startDate;
      this.endDateMonth = findDate.endDate;
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateMonth, this.endDateMonth);
    } else {
      // tslint:disable-next-line:prefer-const
      let findnewdate = new Date(this.startDateWeek);
      findnewdate.setDate(findnewdate.getDate() - 3);
      // tslint:disable-next-line:prefer-const
      let findweekDate = this.getStartDateAndEndDateForWeek(findnewdate.toLocaleDateString());
      this.startDateWeek = findweekDate.startDate;
      this.endDateWeek = findweekDate.endDate;
      this.setDisplayValueForWeek('Project');
      this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
        this.startDateWeek, this.endDateWeek);
    }
  }

  // Call On Select Method for Week View
  callOnSelectForWeek(): void {
    // tslint:disable-next-line:prefer-const
    let findweekDate = this.getStartDateAndEndDateForWeek(this.weekViewDatePicker.toLocaleDateString());
    this.startDateWeek = findweekDate.startDate;
    this.endDateWeek = findweekDate.endDate;
    this.setDisplayValueForWeek('Project');
    this.getTimesheetsByProjctId_and_Worker_User_Id(this.currentprojectId, this.currentWorkerUserId,
      this.startDateWeek, this.endDateWeek);
  }


}



// WEBPACK FOOTER //
// ./src/app/worker/timesheets/timesheets.component.ts